import { Text, type TextProps } from '@/components/typography';

const RuleBuilderText = (props: TextProps) => {
  return <Text {...props} className="leading-10!" />;
};

export default RuleBuilderText;
